import { render, staticRenderFns } from "./ChoOptimizationSlot.vue?vue&type=template&id=7d5ed8fc&"
import script from "./ChoOptimizationSlot.vue?vue&type=script&lang=js&"
export * from "./ChoOptimizationSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports